import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export const FolderCard = ({ folder, index, onOpen }) => {
  const { t } = useTranslation();
  const meta = t(`portfolio.folders.${folder.id}`, { returnObjects: true }) || {};
  const fileCount = folder.files.length;

  return (
    <motion.button
      type="button"
      onClick={() => onOpen(folder)}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      whileHover={{ y: -6 }}
      whileTap={{ scale: 0.98 }}
      transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: index * 0.06 }}
      className="relative block w-full text-left group focus-visible:outline-none"
      data-testid={`portfolio-folder-${folder.id}`}
      aria-label={`${meta.name} — ${t('portfolio.openFolder')}`}
    >
      {/* Folder tab sticking up */}
      <div
        className="absolute -top-3 left-8 w-24 md:w-28 h-3.5 z-0 border-t border-l border-r border-ink"
        style={{ background: folder.tabColor || folder.accent }}
        aria-hidden
      />

      {/* Folder body */}
      <div className="relative box-line pt-8 pb-7 px-6 md:px-7 min-h-[280px] flex flex-col transition-transform duration-500">
        {/* Number + colored square */}
        <div className="flex items-start justify-between mb-6">
          <span className="display text-4xl md:text-5xl text-ink leading-none">
            {String(index + 1).padStart(2, '0')}
          </span>
          <div className="flex flex-col items-end gap-3">
            <span
              className="w-5 h-5 md:w-6 md:h-6 border border-ink"
              style={{ background: folder.accent }}
              aria-hidden
            />
            <span className="font-mono uppercase text-[10px] tracking-widest2 text-ink/60">
              {fileCount} {t('portfolio.itemsSuffix')}
            </span>
          </div>
        </div>

        <h3 className="font-mono uppercase text-base md:text-lg font-medium text-ink leading-snug mb-1">{meta.name}</h3>
        <p className="font-mono uppercase text-[10px] tracking-widest2 text-ink/60 mb-4">{meta.role}</p>

        <p className="serif-italic text-sm md:text-base text-ink/80 leading-snug mb-6 flex-1">{meta.blurb}</p>

        <div className="dash-divider pt-4 flex items-center justify-between">
          <span className="font-mono uppercase text-xs tracking-widest text-ink group-hover:text-clay transition-colors">
            {t('portfolio.openFolder')}
          </span>
          <span aria-hidden className="text-ink transition-transform duration-500 group-hover:translate-x-1">↗</span>
        </div>
      </div>
    </motion.button>
  );
};
